import { render, staticRenderFns } from "./EncuestaCenso.vue?vue&type=template&id=4e228bce&scoped=true"
import script from "./EncuestaCenso.vue?vue&type=script&lang=js"
export * from "./EncuestaCenso.vue?vue&type=script&lang=js"
import style0 from "./EncuestaCenso.vue?vue&type=style&index=0&id=4e228bce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e228bce",
  null
  
)

export default component.exports